import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { connect } from "react-redux";
import "./SBBetSlip.scss";
import {
    AccordionDetails,
    Button,
    CircularProgress,
    Drawer,
    Fab,
} from "@mui/material";
import { ReactComponent as Ellipse1 } from "../../assets/images/ellipse.svg";

import { Global } from "@emotion/react";
import { SxProps, styled } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { RootState } from "../../models/RootState";

import {
    Delete,
    KeyboardArrowLeftRounded,
} from "@mui/icons-material";
import { BsData } from "../../models/ExchBetSlip";
import { clearExchangeBets, exchangeBetOddsChange, removeExchangeBet, setBettingInprogress, setExchangeBetStake } from "../../store/exchBetSlip/exchBetSlipReducer";
import { NumericFormat } from "react-number-format";
import { IonSpinner } from "@ionic/react";
import { toast } from "react-toastify";
import SAP_API from "../../services/sap";
import store from "../../store/store";
import { fetchOpenBets } from "../../store/exchBetSlip/exchBetSlipAction";
import { getUserBalance } from "../../store/authActions";

const drawerBleeding = 56;

const StyledBox = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "light" ? "#fff" : grey[800],
}));

const betSlipStyle = {
    position: "fixed",
    top: "55%",
    bottom: "45%",
    left: 16,
};

type StoreProps = {
    bets: BsData[];
    exchangeBetOddsChange: (index: number, odds: number) => void;
    removeExchangeBet: (index: number) => void;
    bettingInprogress: boolean;
    openBetSlip: boolean;
    setOpenBetSlip: (open: boolean) => void;
    setBettingInprogress: (val: boolean) => void;
    setExchangeBetStake: (
        index: number,
        amount: number,
        type: 'ADD' | 'SET'
    ) => void;
    clearExchangeBets: () => void;
    fetchOpenBets: (eventId: string, sportId: string) => void;
    getUserBalance: () => void;
    //   openBetsData: UserBet[];
    // openSlider: boolean;
    // setOpenSlider: Function;
};

const SBBetSlip: React.FC<StoreProps> = (props) => {
    const {
        bets,
        removeExchangeBet,
        bettingInprogress,
        setBettingInprogress,
        setExchangeBetStake,
        exchangeBetOddsChange,
        clearExchangeBets,
        fetchOpenBets,
        openBetSlip,
        setOpenBetSlip,
        getUserBalance
        // openBetsData,
        // openSlider,
        // setOpenSlider,
    } = props;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const pathname = useLocation().pathname;
    const eventId = useParams().eventId;

    const toggleDrawer = (newOpen: boolean) => () => {
        setOpenBetSlip(newOpen);
    };

    const betPlaceHandler = async () => {
        let data = bets[0]
        if (data.stakeAmount < 1) {
            toast.error("Minimum stake amount required.")
            return false;
        }

        if (
            (data?.minLimit !== 0 && data?.minLimit > data.stakeAmount) ||
            (data?.maxLimit !== 0 && data?.maxLimit < data.stakeAmount)
        ) {
            toast.error("Total stake should not be less than " + data?.minLimit + " and should not exceed " + data?.maxLimit);
            return false;
        }

        if (!data.oddValue) {
            toast.error("Invalid odds")
            return false;
        }

        try {
            setLoading(true);
            setBettingInprogress(true);
            const sbData = store.getState().userDetails.sbData;

            const payload = {
                token: sbData?.token,
                partnerId: sbData?.partnerId,
                operatorId: sbData?.operatorId,
                providerId: data.provider,
                sportId: data.sportId,
                competitionId: data.competitionId,
                eventId: data.eventId,
                betType: data.betType,
                oddValue: data.oddValue,
                stakeAmount: data?.stakeAmount,
                marketType: data.marketType,
                marketName: data.marketName,
                marketId: data.marketId,
                runnerId: data.runnerId,
                runnerName: data.runnerName,
                sessionOutcome: data.sessionOutcome ? data.sessionOutcome : null,
                origin: "SPORTSBOOK"
            };

            const res: any = await SAP_API.post("/core/sportsbet", payload);
            if (res.data.status === "") {
                setLoading(false);
                setBettingInprogress(false);
                if (res?.data?.errorDescription?.toLocaleLowerCase()?.includes("market is expired")) {
                    //   fetchEventInfo(payload.sportId, payload.eventId, navigate)
                }
                toast.error(res.data?.errorDescription);
                return false;
            } else if (res.data.status === "RS_OK") {
                if (res.data.betId && !res.data.errorDescription) {
                    return getBetStatus(data);
                } else {
                    setLoading(false);
                    setBettingInprogress(false);
                    toast.success(res.data?.errorDescription);
                    return true;
                }
            }
        } catch (e) {
            setLoading(false);
            setBettingInprogress(false);
            toast.error("Something went wrong, try again");
            return false;
        }

    };

    const getBetStatus = async (data: BsData) => {
        setLoading(true);
        setBettingInprogress(true);
        const sbData = store.getState().userDetails.sbData;
        const payload = {
            eventId: data.eventId,
            partnerId: sbData?.partnerId,
            operatorId: sbData?.operatorId,
            providerId: sbData?.providerId,
            sportId: data.sportId,
            token: sbData?.token,
        };

        while (1) {
            const res: any = await SAP_API.post("/core/userbet-status", payload);
            if (["BETTING_IN_PROGRESS", "PENDING"].includes(res.data.betStatus)) {
                continue;
            } else if (res.data.betErrorMsg.toLocaleLowerCase().includes("market is expired")) {
                // fetchEventInfo(payload.sportId, payload.eventId, navigate)
                clearExchangeBets();
            } else if (
                res.data.status === "RS_OK" &&
                ["CANCELLED", "EXPIRED", "FAILED"].includes(res.data.betStatus)
            ) {
                setLoading(false);
                setBettingInprogress(false);
                toast.error(
                    res.data.betErrorMsg
                        ? res.data.betErrorMsg
                        : "Bet is not placed, try again");
                return false;
            } else if (res.data?.betStatus === "COMPLETED") {
                setLoading(false);
                setBettingInprogress(false);
                clearExchangeBets();
                getUserBalance();
                fetchOpenBets(data.eventId, data.sportId);

                toast.success(
                    res.data.errorDescription
                        ? res.data.errorDescription
                        : "Bet placed successfully.");
                return true;
            }
        }
    };

    useEffect(() => {
        if (openBetSlip) {
            setOpenBetSlip(true);
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [openBetSlip]);

    return (
        <React.Fragment>
            {(
                <>
                    <Global
                        styles={{
                            ".MuiDrawer-root > .MuiPaper-root": {
                                height: `calc(70% - ${drawerBleeding}px)`,
                                overflow: "visible",
                            },
                        }}
                    />
                    {openBetSlip ? (
                        <div
                            className={
                                openBetSlip
                                    ? `active footer-betslip-header mob-view`
                                    : "footer-betslip-header mob-view"
                            }
                        >
                            <Typography sx={{ p: 2, color: "text.secondary" }}>
                                {/* <BetSlipIcon className="bet-slip-icon" /> */}
                                Bet Slip
                                <Button
                                    onClick={() => {
                                        // setOpenSlider(false);
                                        setOpenBetSlip(false);
                                    }}
                                    className={
                                        openBetSlip ? `rotate arrow-btn` : `arrow-btn`
                                    }
                                >
                                    <KeyboardArrowLeftRounded className="arrow-icon" />
                                </Button>
                            </Typography>
                        </div>
                    ) : (
                        <></>
                    )}
                    <Drawer
                        anchor="bottom"
                        open={openBetSlip}
                        onClose={toggleDrawer(false)}
                        ModalProps={{
                            keepMounted: true,
                        }}
                        className="royal-footer-betslip mob-view"
                    >
                        <StyledBox
                            sx={{
                                px: 2,
                                pb: 2,
                                height: "100%",
                                overflow: "auto",
                            }}
                            className="footer-betslip-ctn"
                        >
                            <div className="right-side-ctn">
                                <div className="content-ctn">
                                    {bets.length > 0 ? (
                                        <AccordionDetails className="accordion-detail-section">
                                            <div className="royal-betslip-ctn">
                                                {loading ? (
                                                    <div className="betslip-progress">
                                                        <div className="centered">
                                                            <CircularProgress className="icon" />
                                                        </div>
                                                    </div>
                                                ) : null}

                                                <div className="body-ctn">
                                                    {bets && bets.length > 0
                                                        ? bets.map((data, index) => {
                                                            return (
                                                                <>
                                                                    <div
                                                                        key={data?.marketName}
                                                                        className={`no-bet-colour bet-body`}
                                                                    >
                                                                        <div
                                                                            className={
                                                                                data?.betType === "BACK"
                                                                                    ? "back-bg bet-card-ctn"
                                                                                    : "lay-bg bet-card-ctn"
                                                                            }
                                                                        >
                                                                            <div
                                                                                className={"bet-card"}
                                                                            >
                                                                                <div>
                                                                                    <div className="event">{data?.eventName}</div>
                                                                                    <Button
                                                                                        className="close-icon"
                                                                                        onClick={() => removeExchangeBet(index)}
                                                                                    >
                                                                                        <Delete />
                                                                                    </Button>
                                                                                </div>
                                                                                <div className="runner">
                                                                                    {data?.runnerName}
                                                                                </div>
                                                                                <div className="market">
                                                                                    {data?.marketName}
                                                                                    {/* {data?.runnerName}{" "} */}
                                                                                </div>

                                                                                <div className="input-row">


                                                                                    <div className="input-row-ctn">
                                                                                        <NumericFormat
                                                                                            placeholder="Bet Amount"
                                                                                            type="tel"
                                                                                            value={data?.stakeAmount}
                                                                                            thousandSeparator={true}
                                                                                            thousandsGroupStyle="lakh"
                                                                                            className="row-input"
                                                                                            decimalScale={3}
                                                                                            allowNegative={false}
                                                                                            disabled={bettingInprogress || loading}
                                                                                            onValueChange={(val: any) => {
                                                                                                setExchangeBetStake(
                                                                                                    index,
                                                                                                    val.floatValue,
                                                                                                    "SET"
                                                                                                );
                                                                                            }}
                                                                                            style={{
                                                                                                height: "36px",
                                                                                                border: 0,
                                                                                                padding: "0px",
                                                                                                width: '100%'
                                                                                            }}
                                                                                            autoFocus={false}
                                                                                        />
                                                                                    </div>

                                                                                    <div className=" odds-ctn">
                                                                                        <div className=" x-ctn">
                                                                                            X
                                                                                        </div>

                                                                                        <div className="row-input-odds">
                                                                                            <NumericFormat
                                                                                                type="tel"
                                                                                                value={data?.oddValue?.toFixed(2)
                                                                                                }
                                                                                                decimalScale={2}
                                                                                                thousandSeparator={true}
                                                                                                thousandsGroupStyle="lakh"
                                                                                                className="row-input "
                                                                                                allowNegative={false}
                                                                                                disabled={true}
                                                                                                onValueChange={(val) => {
                                                                                                    exchangeBetOddsChange(index, parseFloat(val.toString()));
                                                                                                }}
                                                                                                style={{
                                                                                                    height: "42px",
                                                                                                    // border: 0,
                                                                                                    // padding: "2px",
                                                                                                    textAlign: "center",
                                                                                                    // width: '100%',
                                                                                                    // backgroundColor: 'var(--table-head)'
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                className={
                                                                                    data?.betType === "BACK"
                                                                                        ? "back-bg bet-footer"
                                                                                        : "lay-bg bet-footer"
                                                                                }
                                                                            >
                                                                                <div className="stake-section">
                                                                                    <div className="stake-label">
                                                                                        {data.betType === "LAY" ? "Possible win" : "Possible win:"}
                                                                                    </div>

                                                                                    <div className={`stake-value`}>
                                                                                        Pts{" "}
                                                                                        <span
                                                                                            className={
                                                                                                data.betType === "BACK" ? "profit" : "loss"
                                                                                            }
                                                                                        >
                                                                                            {data.marketType === "MATCH_ODDS"
                                                                                                ? data.betType === "BACK"
                                                                                                    ? (
                                                                                                        data.stakeAmount *
                                                                                                        (data.oddValue - 1)
                                                                                                    ).toFixed(2)
                                                                                                    : (
                                                                                                        (data.oddValue - 1) *
                                                                                                        data.stakeAmount
                                                                                                    ).toFixed(2)
                                                                                                : data.marketType === "BOOKMAKER"
                                                                                                    ? data.betType === "BACK"
                                                                                                        ? (
                                                                                                            data.stakeAmount *
                                                                                                            ((data.oddValue + 100) / 100 - 1)
                                                                                                        ).toFixed(2)
                                                                                                        : (
                                                                                                            ((data.oddValue + 100) / 100 - 1) *
                                                                                                            data.stakeAmount
                                                                                                        ).toFixed(2)
                                                                                                    : data.betType === "BACK"
                                                                                                        ? (
                                                                                                            data.stakeAmount *
                                                                                                            ((data.oddValue + 100) / 100 - 1)
                                                                                                        ).toFixed(2)
                                                                                                        : (
                                                                                                            ((data.oddValue + 100) / 100 - 1) *
                                                                                                            data.stakeAmount
                                                                                                        ).toFixed(2)}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="place-section">
                                                                                    {!loading && (
                                                                                        <button
                                                                                            className="place-btn"
                                                                                            disabled={
                                                                                                loading ||
                                                                                                bettingInprogress ||
                                                                                                isNaN(data?.stakeAmount) ||
                                                                                                data?.stakeAmount === 0
                                                                                            }
                                                                                            onClick={betPlaceHandler}
                                                                                        >
                                                                                            {" "}
                                                                                            <div className={
                                                                                                `label`
                                                                                            }>Place Bet</div>
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {/* {oddsChanged || betSuspended ? (
                                                                        <div className="betslip-notification-ctn">
                                                                            <div className="betslip-notification-msg">
                                                                                {betSlipMessage}
                                                                            </div>
                                                                            {oddsChanged && !betSuspended ? (
                                                                                <Button onClick={() => acceptOddsChange()}>
                                                                                    Accept
                                                                                </Button>
                                                                            ) : null}
                                                                        </div>
                                                                    ) : null} */}
                                                                </>
                                                            );
                                                        })
                                                        : null}
                                                </div>
                                            </div>
                                        </AccordionDetails>
                                    ) : (
                                        <div className={`empty-bets`}>
                                            <div className="place-bets-text">Place your bets</div>
                                            <div className="your-selection-text">
                                                Your selection will appear here
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </StyledBox>
                    </Drawer>
                </>
            )}

            {bets.length > 0 ? (
                <Fab
                    color="secondary"
                    aria-label="betslip"
                    sx={betSlipStyle as SxProps}
                    className="mob-view bg-transparent"
                >
                    <Button
                        onClick={() => setOpenBetSlip(true)}
                        disabled={!(bets.length > 0)}
                        className="mob-bet-slip-btn"
                    >
                        <Ellipse1
                            className={`${bets.length > 0
                                ? "center-ellipse-deactivate"
                                : ""
                                }`}
                        />
                    </Button>
                </Fab>
            ) : null}
        </React.Fragment>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        // providerId: state.auth.providerId,
        bets: state.exchBetSlip.bets,
        bettingInprogress: state.exchBetSlip.bettingInprogress,
        // openBetsData: state.betslip.openBets,
    };
};

const mapDispatchToProps = (dispatch: Function) => {
    return {
        removeExchangeBet: (index: number) => dispatch(removeExchangeBet(index)),
        setBettingInprogress: (val: boolean) => dispatch(setBettingInprogress(val)),
        setExchangeBetStake: (index: number, amount: number, type: 'ADD' | 'SET') =>
            dispatch(setExchangeBetStake({ index, amount, type })),
        exchangeBetOddsChange: (index: number, odds: number) =>
            dispatch(exchangeBetOddsChange({ index, odds })),
        clearExchangeBets: () => dispatch(clearExchangeBets({})),
        fetchOpenBets: (eventId: string, sportId: string) =>
            dispatch(fetchOpenBets(eventId, sportId)),
        getUserBalance: () => dispatch(getUserBalance()),
        // setOpenSlider: (value: boolean) => dispatch(setOpenSlider(value)),
        // setSelectedSport: (value: string) => dispatch(setSelectedSport(value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SBBetSlip);
